import { useId, type ReactNode } from "react";

/** Schalter (Handoff Schiefer, Uebergabe Abschnitt 4): Bahn 44 x 26, Knopf 20; aus mit Rand
 *  --pg-field-border (Nicht-Text-Kontrast 3:1), an in --pg-accent. `role="switch"` mit `aria-checked`;
 *  die ganze Zeile mit Beschriftung ist die Trefferflaeche (mindestens 48 hoch). W82 Web-10c (W10C-1): mit `getrennt` ist die
 *  Beschriftung der Name und der Hinweis die Beschreibung (sonst beides der Name, wie bisher). */
export function Schalter(props: { an: boolean; onChange: (an: boolean) => void; children: ReactNode; hinweis?: ReactNode; disabled?: boolean; id?: string; autoFocus?: boolean; getrennt?: boolean }) {
  const nameId = useId();
  const hinweisId = useId();
  const getrennt = props.getrennt === true;
  return (
    <button
      type="button"
      role="switch"
      id={props.id}
      autoFocus={props.autoFocus}
      aria-checked={props.an}
      aria-labelledby={getrennt ? nameId : undefined}
      aria-describedby={getrennt && props.hinweis ? hinweisId : undefined}
      disabled={props.disabled}
      onClick={() => props.onChange(!props.an)}
      className="schalter block min-h-(--pg-hit) w-full text-left disabled:cursor-not-allowed disabled:opacity-40"
    >
      {/* W73d (D-310 H3): der Knopf ist ein Container (bausteine.css); wird er fuer die Schrift zu schmal, steht die Bahn unter
          der Beschriftung wie in iOS bei grosser Schrift */}
      <span className="schalter-reihe flex min-h-(--pg-hit) w-full items-center gap-3">
        {/* W75: bei 320 px und 200 % bricht und trennt die Beschriftung, statt aus der Zeile zu ragen (Blatt „Absender“) */}
        <span className="schalter-text flex min-w-0 flex-1 flex-col break-words hyphens-auto">
          <span id={getrennt ? nameId : undefined} className="t-body">
            {props.children}
          </span>
          {props.hinweis && (
            <span id={getrennt ? hinweisId : undefined} className="t-footnote text-pg-text-2">
              {props.hinweis}
            </span>
          )}
        </span>
        <span aria-hidden className={`schalter-bahn relative inline-flex h-(--schalter-h) w-(--schalter-w) shrink-0 items-center rounded-pill transition-colors duration-(--pg-dur-fast) ${props.an ? "bg-pg-accent" : "bg-pg-surface-2 shadow-(--pg-feld-rand)"}`}>
          <span
            className={`schalter-knopf absolute size-(--schalter-knopf) rounded-pill shadow-e1 transition-transform duration-(--pg-dur-fast) ${props.an ? "translate-x-(--schalter-weg) bg-pg-on-accent" : "translate-x-(--schalter-rand) bg-pg-field-border"}`}
          />
        </span>
      </span>
    </button>
  );
}
